import {
  Button,
  HStack,
  Spacer,
  IconButton,
  useDisclosure,
  NativeSelect,
  Icon,
} from "@chakra-ui/react";
import { observer } from "mobx-react";
import { useState, ChangeEvent } from "react";
import { t } from "i18next";
import { TreatmentType } from "@keita/lanepatrol-sdk";
import { CraNode } from "../../../../../../cra/models/CraNode";
import { CraForecastChangeType } from "../../../../../../survey/models/CraForecastScenario";
import { getTreatmentLabel } from "../../../../../../survey/utils/treatment-labels";
import { StmModal } from "../../../../../../shared/views/StmModal/StmModal";
import { useStores } from "../../../../../../shared/stores/RootStore";
import { formatDistanceByUnit } from "../../../../../../shared/utils/format-utils";
import { InfoOutlineIcon } from "../../../../../../shared/views/icons";

interface Props {
  filteredDistance: number;
  filteredNodes: CraNode[];
  onClose: () => void;
}
const AddTreatmentWhenSuggestedActionBase: React.FC<Props> = ({
  filteredDistance,
  filteredNodes,
  onClose,
}) => {
  const { craForecastStore, surveyStore, filterStore } = useStores();
  const [treatmentType, setTreatmentType] = useState<TreatmentType>();
  const stmModal = useDisclosure();

  const survey = surveyStore.getSelected()!;

  const onChange = (e: ChangeEvent<HTMLSelectElement>) => {
    setTreatmentType(e.target.value as TreatmentType);
  };

  const onSubmit = () => {
    craForecastStore.addAction({
      type: CraForecastChangeType.TreatmentWhenSuggested,
      treatmentType: treatmentType!,
    });
    onClose();
  };

  return (
    <>
      <HStack pb={2}>
        <NativeSelect.Root>
          <NativeSelect.Field
            onChange={onChange}
            value={treatmentType}
            placeholder={t(
              `map:forecast.TreatmentWhenSuggested.treatmentTypePlaceholder`,
            )}
          >
            {filterStore.treatmentsAvailableInCurrentMode.map((treatment) => (
              <option key={treatment} value={treatment}>
                {getTreatmentLabel(treatment)}
              </option>
            ))}
          </NativeSelect.Field>
          <NativeSelect.Indicator />
        </NativeSelect.Root>
        <IconButton
          variant="ghost"
          colorPalette="primary"
          onClick={stmModal.onOpen}
        >
          <Icon as={InfoOutlineIcon} />
        </IconButton>
      </HStack>
      <HStack>
        <Spacer />
        <Button
          flexShrink={0}
          size="sm"
          colorPalette="primary"
          onClick={onSubmit}
          disabled={!treatmentType || !filteredNodes.length}
        >
          {t(`map:forecast.addActionModal.applyBtn`, {
            count: filteredNodes.length,
            total: formatDistanceByUnit(filteredDistance, survey.distanceUnit),
            unit: survey.distanceUnit,
          })}
        </Button>
      </HStack>
      {stmModal.open && (
        <StmModal
          onClose={stmModal.onClose}
          autoFocusTreatmentType={treatmentType}
        />
      )}
    </>
  );
};

export const AddTreatmentWhenSuggestedAction = observer(
  AddTreatmentWhenSuggestedActionBase,
);
